module.exports = __webpack_public_path__ + "static/media/wappen_4c.6fc76f36.png";